'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CSS_MAPPING = {
  about: 'about-hotel',
  'facilities-info': 'facilities',
  conditions: 'conditions',
  'other-info': 'other-information',
  accessibility: 'accessibility',
  activities: 'activities'
}; // FullWidthList

function ListHeader(_ref) {
  var type = _ref.type,
      showAll = _ref.showAll,
      i18n = _ref.i18n,
      title = _ref.title,
      children = _ref.children,
      _onClick = _ref.onClick;

  return _react2.default.createElement(
    'div',
    { className: 'fluid-' + CSS_MAPPING[type] + ' ' + (showAll ? 'show-details' : 'hide-details') },
    _react2.default.createElement(
      'div',
      {
        className: 'toggle-icon-box toggle-' + (showAll ? 'opened' : 'closed'),
        onClick: function onClick(e) {
          return _onClick(e);
        }
      },
      _react2.default.createElement(
        'h2',
        { className: 'toggle-title' },
        i18n.hotelInformation[title]
      ),
      _react2.default.createElement('span', { className: 'toggle' })
    ),
    children
  );
}

ListHeader.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  type: _react.PropTypes.string.isRequired,
  title: _react.PropTypes.string.isRequired,
  showAll: _react.PropTypes.bool,
  children: _react.PropTypes.element,
  onClick: _react.PropTypes.func
};

var FullWidthList = function (_Component) {
  (0, _inherits3.default)(FullWidthList, _Component);

  function FullWidthList(props) {
    (0, _classCallCheck3.default)(this, FullWidthList);

    // This only affects mobile
    var _this = (0, _possibleConstructorReturn3.default)(this, (FullWidthList.__proto__ || (0, _getPrototypeOf2.default)(FullWidthList)).call(this, props));

    _this.state = {
      showAll: false
    };

    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(FullWidthList, [{
    key: 'toggle',
    value: function toggle(e) {
      e.preventDefault();
      this.setState({ showAll: !this.state.showAll });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          i18n = _props.i18n,
          type = _props.type,
          title = _props.title,
          children = _props.children;
      var showAll = this.state.showAll;

      var props = { i18n: i18n, type: type, title: title, showAll: showAll, onClick: this.toggle };

      return _react2.default.createElement(
        'div',
        { className: 'full-width-box hotel-' + type },
        type === 'about' || type === 'facilities-info' ? _react2.default.createElement(
          'div',
          { className: 'full-width-subbox' },
          _react2.default.createElement(
            ListHeader,
            props,
            children
          )
        ) : _react2.default.createElement(
          ListHeader,
          props,
          children
        )
      );
    }
  }]);
  return FullWidthList;
}(_react.Component);

FullWidthList.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  type: _react.PropTypes.string.isRequired,
  title: _react.PropTypes.string.isRequired,
  children: _react.PropTypes.element
};

exports.default = FullWidthList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FullWidthList.js
// module id = 1202
// module chunks = 0